/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    /**
     * Copy/paste dropdowns just for domain list menu buttons
     */
    $('.domains-list').on('click', '.drop-down-button', function (e) {
        // Move out of body
        $('#page-body').append($($(this).data('dropdown')));

        e.preventDefault();
        e.stopPropagation();
        var $caller = $(this);
        var $dropdown = $($caller.data('dropdown'));
        if ($caller.hasClass('disabled')) {

        } else {
            $.powerTip.hide();
            $('.power-tip').powerTip({
                manual: true
            });
            if ($($dropdown).is(':visible')) {
                $('.power-tip').powerTip({
                    placement: 's'
                });
                $dropdown.fadeOut();
                $caller.removeClass('active');
            } else {
                $('.dropdown:visible').fadeOut();
                $caller.addClass('active');
                $(document).on('click.dropdown', function (e) {
                    var $target = $(e.target);
                    if (!$target.closest('.dropdown').length) {
                        $caller.removeClass('active');
                        $dropdown.fadeOut(function () {
                            $(document).off('click.dropdown');
                        });
                        $('.power-tip').powerTip({
                            placement: 's'
                        });
                    }
                });
                if ($caller.data('dropdown-right-regular') !== undefined) {
                    $dropdown.css({
                        top: $caller.offset().top + $caller.height() + 8,
                        left: $caller.offset().left + $caller.width() - $dropdown.width()
                    }).fadeIn(200);
                } else {
                    $dropdown.css({
                        top: $caller.offset().top + $caller.height() + 8,
                        left: ($caller.data('dropdown-right') !== undefined && $(window).width() >= breakpoints.screenSm) ? $caller.offset().left + $caller.width() - $dropdown.width() : $caller.offset().left
                    }).fadeIn(200);
                }
            }
        }
    });

    /**
     * Add custom domain
     */
    $('#new-domain-popup').on('click', '.add-domain', function() {
        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                form.find('input, textarea').removeClass('error');
                form.find('label.error').text('');
                if (response.status == 'success') {
                    form.find('input[name=domain], input[name=default_url]').val(null);
                    form.find('input[name=domain], input[name=not_found_url]').val(null);
                    $('.domains-list').empty().append($(response.html));
                    info(response.message);
                    hidePopup();
                }
                else {
                    $.each(response.errors, function(k, v) {
                        form.find('[name=' + k + ']').addClass('error')
                            .closest('.form-field')
                            .find('label.error').text(v);
                    });
                }
            },
            'json'
        );

        return false;
    });

    /**
     * Edit domain default redirect URL
     */
    $('.domains-list').on('click', '.button-edit-default-url', function() {
        var $this = $(this);
        if ($this.hasClass('active')) {
            // Submit
        }
        else {
            $this.siblings('input').focus();
            return false;
        }
    })
    .on('click', '.button-edit-default-url-cancel', function(){
        var btn = $(this);
        btn.siblings('.button-edit-default-url').removeClass('active').text('EDIT');
        btn.removeClass('active');
        btn.siblings('input[name=default_url]').val(btn.data('original-value')).blur();
        return false;
    })
    .on('focus', '.link input[name=default_url]', function(){
        $(this).trigger('change');
    })
    .on('click', '.button-edit-not-found-url', function() {
        var $this = $(this);
        if ($this.hasClass('active')) {
            // Submit
        }
        else {
            $this.siblings('input').focus();
            return false;
        }
    })
    .on('click', '.button-edit-not-found-url-cancel', function(){
        var btn = $(this);
        btn.siblings('.button-edit-not-found-url').removeClass('active').text('EDIT');
        btn.removeClass('active');
        btn.siblings('input[name=not_found_url]').val(btn.data('original-value')).blur();
        return false;
    })
    .on('focus', '.link input[name=not_found_url]', function(){
        $(this).trigger('change');
    })
    .on('click', '.button-edit-retargeting', function() {
        var $this = $(this);
        if ($this.hasClass('active')) {
            // Submit
        }
        else {
            $this.siblings('input').focus();
            return false;
        }
    })
    .on('click', '.button-edit-retargeting-cancel', function(){
        var btn = $(this);
        btn.siblings('.button-edit-retargeting').removeClass('active').text('EDIT');
        btn.removeClass('active');
        btn.siblings('input.tracking-id-field').val(btn.data('original-value')).blur();
        return false;
    })
    .on('focus', '.link input.tracking-id-field', function(){
        $(this).trigger('change');
    })
    ;

    /**
     * Domain dropdown delete
     */
    $('body').on('click', '.button-settings.delete-domain', function() {
        if (!window.confirm($(this).data('confirm'))) {
            return false;
        }

        var form = $(this).closest('form');
        var domain = $('#domain-' + form.find('[name=id]').val());

        $.post(
            $(this).attr('href'),
            form.serialize(),
            function(response) {
                info(response.message);
                domain.remove();
                $('#domain-list-dropdown-' + form.find('[name=id]').val()).fadeOut();
            },
            'json'
        );

        return false;
    });
});

function CustomDomainChangeProtocol(domain_id) {
    var token = $("#custom_domain_change_protocol_csrf_token").val();
    $.ajax({
        type: 'POST',
        url: "./../settings/custom-domains/change_protocol",
        data: {
            'domain_id': domain_id,
            '_token': token,
        },
        success: function (data) {

        },
        error: function () {
            alert('Error');
        }
    });
}

function CustomDomainChangePrivacy(domain_id) {
    var token = $("#custom_domain_change_privacy_csrf_token").val();
    $.ajax({
        type: 'POST',
        url: "./../settings/custom-domains/change_privacy",
        data: {
            'domain_id': domain_id,
            '_token': token,
        },
        success: function (data) {

        },
        error: function () {
            alert('Error');
        }
    });
}

function copyToClipboard(id) {
    var clipboard = new Clipboard('.button');
    clipboard.on('success', function(e) {
        $('#domain_dns_record_'+id).addClass('copied');
        setTimeout(
            function() {
                $('.link-animation').removeClass('copied');
            },
            500
        );
        e.clearSelection();
    });
}